import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router'
import { UserMessageService } from '../../services/userMessageService';
import { VideoMessageAPI } from '../../services/videoMessageAPI';
import { EnvironmentService } from '../../services/environmentService';
import { AuthService } from '../../services/authService';

@inject(UserMessageService, Router, VideoMessageAPI, EnvironmentService, AuthService)
export class VideoMessageLanding  {
    constructor(userMessageService, router, api, envService, authService) {
        this.userMessageService = userMessageService;
        this.router = router;
        this.api = api;
        this.envService = envService;
        this.authService = authService;
        // this.testimonialCaptureAPI = testimonialCaptureAPI;
        this.app_name = "Magnfi";
        this.home_url = window.home_url;
        this.logo_img = "images/magnfi-logo-small.png";

        this.fileName =  null;
        this.playClicked = false;

        if (window.whitelabel) {

            this.app_name = window.app_name;
            this.logo_img = "api/whitelabel/getFile?file=site_logo";
        }

        this.cta_valid = false;
        this.awsUrl = null;
        this.awsUrlInEmail = null;

        this.vid = "";

        this.Iphone = false;

        this.videoDivIphone = "";
        this.videoPreviewMobileIphone = "";
    }

    activate(model, route,parsms) {
        // console.log(model,route.parsms)
        let queryStringSplit = window.location.hash.split("?")
        let queryString = queryStringSplit.length==2?queryStringSplit[1]:""
        const params = new URLSearchParams(queryString);
        if(params.get('token'))
        localStorage.setItem('token',params.get('token'));

        // this.accountApi.getByOwner(params.get('token'))
        this.link_key = model.key;
        this.api.getDataByKey(this.link_key, this.apiSuccessCallback.bind(this), () => {this.router.navigate(this.home_url);})

    }

    checkheight() {

        var timeoutFunction = setTimeout(function() {
            this.checkheight();
          }.bind(this), 1000);
        let heightVideo2 = $(document.getElementById("videoEmailPlayer")).height();
        let widthVideo2 = $(document.getElementById("videoEmailPlayer")).width();
        let duration = this.videoPreviewPlayer.duration;
        let currentTime = this.videoPreviewPlayer.currentTime;
        let percentage = (currentTime/duration) * 100;

        this.api.updateAveragePercentageOfVideoEmailPlayed (this.link_key, percentage, () => {}, () => {});
        if(heightVideo2 < widthVideo2) {
            this.videoDivIphone = "";
            this.videoPreviewMobileIphone = "";
        }
        console.log("video height compose", heightVideo2,widthVideo2);
    }

    apiSuccessCallback(data) {

        this.link_id = data.link_id;
        this.org_name = data.org_name;
        this.first_name = data.first_name;
        this.email = data.email;
        this.body = data.body;
        this.cta_link = data.cta_link;
        this.cta_link_text = data.cta_link_text;
        this.cta_phone_link = data.cta_phone_link;
        this.status = data.status;


        this.cta_valid = this.cta_link && this.cta_link_text && (this.cta_link.startsWith("https://") || this.cta_link.startsWith("http://"));

        this.show_video = false;

        if(this.authService.isLoggedIn() && this.authService.getAccount().link_id == this.link_id) {

            this.api.getVideo(this.link_key,this.authService.getUser().token, (data) => {

                if(typeof(data) === "object" && data.hasOwnProperty("video_url")) {

                    this.awsUrl = data.video_url;
                    this.videoPreviewPlayer.src = this.awsUrl==null? "api/videoMessage/getUserVideo/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date() : this.awsUrl;

                };

                if(typeof(data) === "object" && data.hasOwnProperty("gif_url")) {

                    this.gif_url = data.gif_url;
                };

                if(typeof(data) === "object" && data.hasOwnProperty("video")) {

                    this.videoDivIphone = (data.video.iphone_preset && data.video.iphone_preset == 1) ? "videoDiv" : "";
                     this.videoPreviewMobileIphone = (data.video.iphone_preset && data.video.iphone_preset == 1) ? "videoPreviewMobile" : "";

                }
            },()=> {
                console.log("error aws");
            });

            if(this.awsUrl == null) {

                this.videoPreviewPlayer.src = "api/videoMessage/getUserVideo/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();

            }

            this.videoPreviewPlayer.poster = "api/videoMessage/getUserFrame/" + this.link_key + "?raw=1&Authorization=" + this.authService.getUser().token + "&t=" + new Date();
            this.show_video = true;

            this.videoPreviewPlayer.load();

        } else if (this.authService.isLoggedIn() && this.authService.getUser().role == "ADMIN") {

            this.api.getAdminVideo(this.link_key,this.authService.getUser().token, (data) => {

                if(typeof(data) === "object" && data.hasOwnProperty("video_url")) {

                    this.awsUrl = data.video_url;
                    this.videoPreviewPlayer.src = this.awsUrl==null? "api/admin/videoMessage/getUserVideo/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date() : this.awsUrl;

                };

                if(typeof(data) === "object" && data.hasOwnProperty("video")) {

                    this.videoDivIphone = (data.video.iphone_preset && data.video.iphone_preset == 1) ? "videoDiv" : "";
                     this.videoPreviewMobileIphone = (data.video.iphone_preset && data.video.iphone_preset == 1) ? "videoPreviewMobile" : "";
                }
            },()=> {
                console.log("error aws");
            });

            if(this.awsUrl == null) {

            this.videoPreviewPlayer.src = "api/admin/videoMessage/getUserVideo/" + this.link_key + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();

        }

            this.videoPreviewPlayer.poster = "api/admin/videoMessage/getUserFrame/" + this.link_key + "?raw=1&Authorization=" + this.authService.getUser().token + "&t=" + new Date();
            this.show_video = true;
            this.videoPreviewPlayer.load();

        }
        else {
            if(this.status == 100 || this.status == 3) {

                this.api.emailGetVideo(this.link_key, (data) => {

                    if(typeof(data) === "object" && data.hasOwnProperty("video_url")) {

                        this.awsUrlInEmail = data.video_url;
                        this.videoPreviewPlayer.src = this.awsUrlInEmail==null? "api/videoMessage/getUserVideo/" + this.link_key : this.awsUrlInEmail;

                    };

                    if(typeof(data) === "object" && data.hasOwnProperty("video")) {

                        this.videoDivIphone = (data.video.iphone_preset && data.video.iphone_preset == 1) ? "videoDiv" : "";
                         this.videoPreviewMobileIphone = (data.video.iphone_preset && data.video.iphone_preset == 1) ? "videoPreviewMobile" : "";

                        }
                },()=> {
                    console.log("error aws in email");
                });

                if(this.awsUrlInEmail==null) {

                 this.videoPreviewPlayer.src = "api/videoMessage/getVideo/" + this.link_key;

                }

                this.videoPreviewPlayer.poster = "api/videoMessage/getFrame/" + this.link_key + "?raw=1";
                this.show_video = true;
                this.videoPreviewPlayer.load();

            } else {
                this.router.navigate(this.home_url);
            }
        }

    }

    // naturalSize() {e
    //     var myVideo = document.getElementsByTagName('video')[0];
    //     myVideo.height = myVideo.videoHeight * 2;
    //     myVideo.width = myVideo.videoWidth * 2;
    //     // alert("function called");
    // }

        // init() {
        //     vid = document.getElementById("myVideo");
        //     vid.addEventListener("loadedmetadata", addFullscreenButton, false);
        // }
        addFullscreenButton() {
            this.vid.webkitEnterFullscreen();
            // if (this.vid.webkitSupportsFullscreen) {
            //     var fs = document.getElementById("fs");
            //     fs.style.visibility = "visible";
            // }
        }
        // goFullscreen() {
        //     this.vid.webkitEnterFullscreen();
        // }


    videoPlayed() {
        // var myVideo = document.getElementsByTagName('video')[0];
        //    myVideo.height = myVideo.videoHeight * 2;

        // var myVideo = document.getElementsByTagName('video')[0];
        // myVideo.addEventListener('loadedmetadata', this.naturalSize(), false);

            // this.vid = document.getElementsByTagName("video")[0];
            // console.log("document", this.vid);
            // this.vid.addEventListener("loadedmetadata", this.addFullscreenButton(), false);
            // console.log("document out");

        if(!this.authService.isLoggedIn()) {
            if(!this.playClicked) {
            this.api.videoPlayed({key: this.link_key}, () => {}, () => {});
            this.playClicked = !this.playClicked;
            }
        }
    }

    // fileSuccessCallBack(data) {
    //     console.log("fileName return",data )
    //     this.fileName = data;

    // }

    ctaLinkClicked() {
        this.api.addCTALog(this.link_key,'link',() => {
        window.open(this.cta_link, '_blank');
        }, ()=> {});

    }

    ctaPhoneClicked() {
        this.api.addCTALog(this.link_key,'phone',() => {
            window.open('tel: '+this.cta_phone_link,'_self');
        }, ()=> {});
    }

}
